(function () {
  let bombasMediaManifestPromise = null;
  let bombasDetailsManifestPromise = null;

  function normalizeBombasKey(value) {
    return String(value || "").trim().toLowerCase();
  }

  function escapeBombasHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function normalizeBombasUrl(value) {
    const text = String(value || "").trim();
    if (!text) {
      return "";
    }
    if (text.startsWith("//")) {
      return "https:" + text;
    }
    return text;
  }

  function compactBombasText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function bombasGalleryFit(type, alt) {
    const typeToken = normalizeBombasKey(type);
    const altToken = normalizeBombasKey(alt);
    if (typeToken.includes("layflat") || typeToken.includes("primary") || typeToken.includes("flat")) {
      return "contain";
    }
    if (
      typeToken.includes("onmodel") ||
      typeToken.includes("detail") ||
      typeToken.includes("lifestyle") ||
      altToken.includes("onmodel") ||
      altToken.includes("detail") ||
      altToken.includes("lifestyle")
    ) {
      return "cover";
    }
    return "contain";
  }

  function loadBombasMediaManifest(url) {
    if (!url) {
      return Promise.resolve(null);
    }
    if (!bombasMediaManifestPromise) {
      bombasMediaManifestPromise = fetch(url, { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) {
            throw new Error("manifest fetch failed");
          }
          return response.json();
        })
        .catch(() => null);
    }
    return bombasMediaManifestPromise;
  }

  function loadBombasDetailsManifest(url) {
    if (!url) {
      return Promise.resolve(null);
    }
    if (!bombasDetailsManifestPromise) {
      bombasDetailsManifestPromise = fetch(url, { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) {
            throw new Error("details manifest fetch failed");
          }
          return response.json();
        })
        .catch(() => null);
    }
    return bombasDetailsManifestPromise;
  }

  function initCardSwatches(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-bombas-card]").forEach((card) => {
      const mediaImage = card.querySelector("[data-card-image]");
      const mediaLink = card.querySelector("[data-card-media-link]");
      const titleLink = card.querySelector("[data-card-link]");
      const priceNode = card.querySelector("[data-card-price]");
      const compareNode = card.querySelector("[data-card-compare]");
      const swatches = Array.from(card.querySelectorAll("[data-card-variant-url]"));
      if (!mediaImage || !swatches.length) {
        return;
      }

      const setActive = (button) => {
        swatches.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      };

      const syncCard = (button) => {
        const image = button.getAttribute("data-card-variant-image");
        const imageAlt = button.getAttribute("data-card-variant-image-alt");
        const url = button.getAttribute("data-card-variant-url");
        const price = button.getAttribute("data-card-variant-price");
        const compare = button.getAttribute("data-card-variant-compare");
        if (image) {
          if (mediaImage.getAttribute("src") !== image) {
            mediaImage.classList.add("is-swapping");
            mediaImage.addEventListener(
              "load",
              function handleLoad() {
                mediaImage.classList.remove("is-swapping");
              },
              { once: true }
            );
          }
          mediaImage.src = image;
          mediaImage.srcset = "";
          if (imageAlt) {
            mediaImage.alt = imageAlt;
          }
        }
        if (url && titleLink) {
          titleLink.href = url;
        }
        if (url && mediaLink) {
          mediaLink.href = url;
        }
        if (price && priceNode && price !== "$0.00") {
          priceNode.textContent = price;
        }
        if (compareNode) {
          if (compare) {
            compareNode.textContent = compare;
            compareNode.hidden = false;
          } else {
            compareNode.hidden = true;
          }
        }
        setActive(button);
      };

      swatches.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          syncCard(button);
        });
      });
    });
  }

  function initHeaderMega(scope) {
    const root = scope || document;
    const header = root.querySelector("[data-bombas-header]");
    if (!header) {
      return;
    }

    const desktopQuery = window.matchMedia("(min-width: 1101px)");
    const items = Array.from(header.querySelectorAll("[data-bombas-nav-item]"));
    let closeTimer;

    const syncExpanded = (item, expanded) => {
      const trigger = item.querySelector("[data-bombas-nav-trigger]");
      if (trigger) {
        trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
    };

    const closeAll = () => {
      window.clearTimeout(closeTimer);
      items.forEach((item) => {
        item.classList.remove("is-open");
        syncExpanded(item, false);
      });
    };

    const openItem = (item) => {
      if (!desktopQuery.matches || !item.querySelector("[data-bombas-mega]")) {
        return;
      }
      window.clearTimeout(closeTimer);
      items.forEach((other) => {
        const isCurrent = other === item;
        other.classList.toggle("is-open", isCurrent);
        syncExpanded(other, isCurrent);
      });
    };

    const scheduleClose = () => {
      if (!desktopQuery.matches) {
        return;
      }
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, 110);
    };

    items.forEach((item) => {
      const trigger = item.querySelector("[data-bombas-nav-trigger]");
      const panel = item.querySelector("[data-bombas-mega]");
      if (!trigger || !panel) {
        return;
      }

      item.addEventListener("mouseenter", function () {
        openItem(item);
      });
      item.addEventListener("mouseleave", function () {
        scheduleClose();
      });
      trigger.addEventListener("focus", function () {
        openItem(item);
      });
      item.addEventListener("focusout", function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            scheduleClose();
          }
        }, 0);
      });
    });

    header.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeAll();
      }
    });

    document.addEventListener("pointerdown", function (event) {
      if (!header.contains(event.target)) {
        closeAll();
      }
    });

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener("change", closeAll);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(closeAll);
    }
  }

  function initHeaderDrawer(scope) {
    const root = scope || document;
    const header = root.querySelector("[data-bombas-header]");
    if (!header) {
      return;
    }

    const mobileQuery = window.matchMedia("(max-width: 820px)");
    const toggle = header.querySelector("[data-bombas-drawer-toggle]");
    const shell = header.querySelector("[data-bombas-drawer-shell]");
    const panel = header.querySelector("[data-bombas-drawer-panel]");
    let closeTimer = 0;
    let returnFocus = null;

    if (!toggle || !shell || !panel) {
      return;
    }

    if (toggle.getAttribute("data-bombas-drawer-ready") === "true") {
      return;
    }
    toggle.setAttribute("data-bombas-drawer-ready", "true");

    const shellId = shell.getAttribute("data-bombas-drawer-shell-id");
    if (shell.parentElement !== document.body) {
      if (shellId) {
        const previousShell = document.body.querySelector(
          '[data-bombas-drawer-shell-id="' + shellId + '"]',
        );
        if (previousShell && previousShell !== shell) {
          previousShell.remove();
        }
      }
      document.body.appendChild(shell);
    }

    const closeButtons = Array.from(shell.querySelectorAll("[data-bombas-drawer-close]"));

    const syncState = (isOpen) => {
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
      shell.classList.toggle("is-open", isOpen);
      header.classList.toggle("is-drawer-open", isOpen);
      document.body.classList.toggle("has-bombas-drawer", isOpen);
    };

    const openDrawer = () => {
      if (!mobileQuery.matches) {
        return;
      }
      window.clearTimeout(closeTimer);
      returnFocus = document.activeElement;
      shell.hidden = false;
      window.requestAnimationFrame(function () {
        syncState(true);
        const focusTarget =
          panel.querySelector(".bombas-header__drawer-close") ||
          panel.querySelector(".bombas-header__drawer-link");
        if (focusTarget) {
          focusTarget.focus();
        }
      });
    };

    const closeDrawer = (restoreFocus = true) => {
      if (shell.hidden) {
        return;
      }
      window.clearTimeout(closeTimer);
      syncState(false);
      closeTimer = window.setTimeout(function () {
        if (!shell.classList.contains("is-open")) {
          shell.hidden = true;
          if (restoreFocus && returnFocus && typeof returnFocus.focus === "function") {
            returnFocus.focus();
          }
        }
      }, 220);
    };

    toggle.addEventListener("click", function () {
      if (shell.hidden || !shell.classList.contains("is-open")) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", function () {
        closeDrawer();
      });
    });

    panel.querySelectorAll("a[href]").forEach((link) => {
      link.addEventListener("click", function () {
        closeDrawer(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !shell.hidden) {
        closeDrawer();
      }
    });

    const handleViewportChange = (event) => {
      if (!event.matches) {
        window.clearTimeout(closeTimer);
        shell.hidden = true;
        syncState(false);
      }
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", handleViewportChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(handleViewportChange);
    }
  }

  function initProductDetailsModal(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-bombas-product]").forEach((productRoot) => {
      const openButton = productRoot.querySelector("[data-details-open]");
      const modal = productRoot.querySelector("[data-details-modal]");
      const body = productRoot.querySelector("[data-details-body]");
      const closeButtons = Array.from(productRoot.querySelectorAll("[data-details-close]"));
      const fallbackScript = productRoot.querySelector("[data-product-details-fallback]");
      const productHandle = productRoot.getAttribute("data-bombas-product-handle") || "";
      const detailsManifestUrl = productRoot.getAttribute("data-bombas-details-manifest-url") || "";
      const highlightTitleNode = productRoot.querySelector(".bombas-pdp-o__highlight-title");
      const highlightCopyNode = productRoot.querySelector(".bombas-pdp-o__highlight-copy");
      const pageTitleNode = productRoot.querySelector(".bombas-pdp-o__title");
      const detailsPromise = loadBombasDetailsManifest(detailsManifestUrl);
      let fallbackData = {};

      if (!openButton || !modal || !body) {
        return;
      }

      if (fallbackScript) {
        try {
          fallbackData = JSON.parse(fallbackScript.textContent || "{}");
        } catch (error) {
          fallbackData = {};
        }
      }

      const extractFallbackIntro = () => {
        const descriptionHtml = String(fallbackData.descriptionHtml || "");
        if (!descriptionHtml) {
          return [];
        }
        const wrapper = document.createElement("div");
        wrapper.innerHTML = descriptionHtml;
        const paragraphs = Array.from(wrapper.querySelectorAll("p"))
          .map((node) => compactBombasText(node.textContent))
          .filter(Boolean);
        if (paragraphs.length) {
          return paragraphs;
        }
        const text = compactBombasText(wrapper.textContent);
        return text ? [text] : [];
      };

      const renderIntro = (entry, intro) => {
        const paragraphs = Array.isArray(intro) ? intro.filter(Boolean) : [];
        const title = compactBombasText((entry && entry.title) || (pageTitleNode && pageTitleNode.textContent));
        if (!title && !paragraphs.length) {
          return "";
        }
        if (!paragraphs.length) {
          return (
            '<section class="bombas-pdp-o__details-section">' +
            '<h3 class="bombas-pdp-o__details-section-heading bombas-pdp-o__details-section-heading--product">' +
            escapeBombasHtml(title) +
            "</h3>" +
            "</section>"
          );
        }
        return (
          '<section class="bombas-pdp-o__details-section">' +
          '<h3 class="bombas-pdp-o__details-section-heading bombas-pdp-o__details-section-heading--product">' +
          escapeBombasHtml(title) +
          "</h3>" +
          '<div class="bombas-pdp-o__details-copy">' +
          paragraphs
            .map((paragraph) => "<p>" + escapeBombasHtml(paragraph) + "</p>")
            .join("") +
          "</div>" +
          "</section>"
        );
      };

      const renderHighlight = () => {
        const title = compactBombasText(highlightTitleNode && highlightTitleNode.textContent);
        const copy = compactBombasText(highlightCopyNode && highlightCopyNode.textContent);
        if (!title && !copy) {
          return "";
        }
        return (
          '<section class="bombas-pdp-o__details-section">' +
          '<h3 class="bombas-pdp-o__details-section-heading">Product Highlight</h3>' +
          '<div class="bombas-pdp-o__details-highlight">' +
          '<div class="bombas-pdp-o__details-highlight-icon" aria-hidden="true"><span></span><span></span><span></span></div>' +
          '<div class="bombas-pdp-o__details-highlight-copy">' +
          (title ? '<h4 class="bombas-pdp-o__details-highlight-title">' + escapeBombasHtml(title) + "</h4>" : "") +
          (copy ? '<p class="bombas-pdp-o__details-highlight-text">' + escapeBombasHtml(copy) + "</p>" : "") +
          "</div></div></section>"
        );
      };

      const renderFeatures = (features) => {
        const rows = Array.isArray(features) ? features.filter((feature) => compactBombasText(feature && feature.title)) : [];
        if (!rows.length) {
          return "";
        }
        return (
          '<section class="bombas-pdp-o__details-section">' +
          '<h3 class="bombas-pdp-o__details-section-heading">Features</h3>' +
          '<div class="bombas-pdp-o__details-features">' +
          rows
            .map((feature) => {
              const imageUrl = normalizeBombasUrl(feature.image);
              return (
                '<div class="bombas-pdp-o__details-feature">' +
                '<div class="bombas-pdp-o__details-feature-icon">' +
                (imageUrl
                  ? '<img src="' + escapeBombasHtml(imageUrl) + '" alt="" loading="lazy">'
                  : '<span class="bombas-pdp-o__details-feature-icon-fallback" aria-hidden="true"></span>') +
                "</div>" +
                '<div class="bombas-pdp-o__details-feature-copy">' +
                '<h4 class="bombas-pdp-o__details-feature-title">' + escapeBombasHtml(feature.title) + "</h4>" +
                "</div></div>"
              );
            })
            .join("") +
          "</div></section>"
        );
      };

      const renderMaterials = (materials, note) => {
        const rows = Array.isArray(materials) ? materials.filter(Boolean) : [];
        const noteText = compactBombasText(note);
        if (!rows.length && !noteText) {
          return "";
        }
        return (
          '<section class="bombas-pdp-o__details-section">' +
          '<h3 class="bombas-pdp-o__details-section-heading">Full Fabric Content</h3>' +
          '<div class="bombas-pdp-o__details-copy bombas-pdp-o__details-copy--materials">' +
          rows
            .map((row) => "<p>" + escapeBombasHtml(String(row || "")).replace(/\n/g, "<br>") + "</p>")
            .join("") +
          (noteText ? "<p>" + escapeBombasHtml(noteText) + "</p>" : "") +
          "</div></section>"
        );
      };

      const renderCare = (care) => {
        const text = compactBombasText(care);
        if (!text) {
          return "";
        }
        return (
          '<section class="bombas-pdp-o__details-section">' +
          '<h3 class="bombas-pdp-o__details-section-heading">Care Details</h3>' +
          '<div class="bombas-pdp-o__details-copy"><p>' + escapeBombasHtml(text) + "</p></div></section>"
        );
      };

      const openModal = () => {
        modal.hidden = false;
        document.documentElement.classList.add("has-bombas-details-modal");
        document.body.classList.add("has-bombas-details-modal");
        const closeButton = modal.querySelector(".bombas-pdp-o__details-close");
        window.requestAnimationFrame(() => {
          if (closeButton) {
            closeButton.focus();
          }
        });
      };

      const closeModal = () => {
        modal.hidden = true;
        document.documentElement.classList.remove("has-bombas-details-modal");
        document.body.classList.remove("has-bombas-details-modal");
      };

      const renderModal = (entry) => {
        const intro = (entry && Array.isArray(entry.intro) && entry.intro.length ? entry.intro.slice() : extractFallbackIntro()).filter(Boolean);
        body.innerHTML =
          renderIntro(entry, intro) +
          renderHighlight() +
          renderFeatures(entry && entry.features) +
          renderMaterials(entry && entry.materials, entry && entry.materialsNote) +
          renderCare(entry && entry.care);
      };

      const renderLoadingState = () => {
        body.innerHTML =
          '<section class="bombas-pdp-o__details-section bombas-pdp-o__details-section--loading">' +
          '<h3 class="bombas-pdp-o__details-section-heading bombas-pdp-o__details-section-heading--product">' +
          escapeBombasHtml(compactBombasText((pageTitleNode && pageTitleNode.textContent) || "Product Details")) +
          "</h3>" +
          '<div class="bombas-pdp-o__details-copy"><p>Loading product details...</p></div>' +
          "</section>";
      };

      openButton.addEventListener("click", function (event) {
        event.preventDefault();
        renderLoadingState();
        openModal();
        detailsPromise.then((manifest) => {
          renderModal((manifest && manifest[productHandle]) || null);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          closeModal();
        });
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !modal.hidden) {
          closeModal();
        }
      });
    });
  }

  function initSizeGuideModal(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-bombas-product]").forEach((productRoot) => {
      const openButtons = Array.from(productRoot.querySelectorAll("[data-size-guide-open]"));
      const modal = productRoot.querySelector("[data-size-guide-modal]");
      const closeButtons = Array.from(productRoot.querySelectorAll("[data-size-guide-close]"));

      if (!openButtons.length || !modal) {
        return;
      }

      const openModal = () => {
        modal.hidden = false;
        document.documentElement.classList.add("has-bombas-size-guide-modal");
        document.body.classList.add("has-bombas-size-guide-modal");
        const closeButton = modal.querySelector(".bombas-pdp-o__size-guide-close");
        window.requestAnimationFrame(() => {
          if (closeButton) {
            closeButton.focus();
          }
        });
      };

      const closeModal = () => {
        modal.hidden = true;
        document.documentElement.classList.remove("has-bombas-size-guide-modal");
        document.body.classList.remove("has-bombas-size-guide-modal");
      };

      openButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          openModal();
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          closeModal();
        });
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !modal.hidden) {
          closeModal();
        }
      });
    });
  }

  function initProductForms(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-bombas-product]").forEach((productRoot) => {
      const script = productRoot.querySelector("[data-product-json]");
      if (!script) {
        return;
      }

      let product;
      try {
        product = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      const addButton = productRoot.querySelector("[data-add-to-cart]");
      const variantInput = productRoot.querySelector("[data-variant-id-input]");
      const priceNodes = Array.from(productRoot.querySelectorAll("[data-product-price]"));
      const compareNodes = Array.from(productRoot.querySelectorAll("[data-product-compare]"));
      const savingsNodes = Array.from(productRoot.querySelectorAll("[data-product-savings]"));
      const productHandle = productRoot.getAttribute("data-bombas-product-handle") || "";
      const mediaManifestUrl = productRoot.getAttribute("data-bombas-media-manifest-url") || "";
      const mainImage = productRoot.querySelector("[data-product-main-image]");
      const thumbButtons = Array.from(productRoot.querySelectorAll("[data-media-id]"));
      const optionButtons = Array.from(productRoot.querySelectorAll("[data-option-index]"));
      const optionValueNodes = Array.from(productRoot.querySelectorAll("[data-option-current-value]"));
      const galleryTrack = productRoot.querySelector("[data-gallery-track]");
      let galleryItems = Array.from(productRoot.querySelectorAll("[data-gallery-item]"));
      const galleryPrev = productRoot.querySelector("[data-gallery-prev]");
      const galleryNext = productRoot.querySelector("[data-gallery-next]");
      const galleryCurrentNode = productRoot.querySelector("[data-gallery-current]");
      const galleryTotalNode = productRoot.querySelector("[data-gallery-total]");
      const isOfficialPdp = productRoot.hasAttribute("data-bombas-pdp-official");
      const selected = [];
      const colorOptionIndex = optionValueNodes.length
        ? Number(optionValueNodes[0].getAttribute("data-option-current-value"))
        : -1;
      const sizeOptionIndex = optionValueNodes.length > 1
        ? Number(optionValueNodes[1].getAttribute("data-option-current-value"))
        : -1;
      let galleryIndex = 0;
      let officialMediaEntry = null;
      let officialGalleryKey = "";

      const isUsableVariant = (variant) => {
        return Boolean(variant && variant.available && Number(variant.price) > 0);
      };

      const usableVariants = product.variants.filter(isUsableVariant);
      const variantPool = usableVariants.length ? usableVariants : product.variants;
      const selectedVariant =
        (isUsableVariant(product.selected_or_first_available_variant)
          ? product.selected_or_first_available_variant
          : null) ||
        variantPool[0] ||
        product.selected_or_first_available_variant ||
        product.variants[0];

      if (!selectedVariant) {
        return;
      }

      selectedVariant.options.forEach((value, index) => {
        selected[index] = value;
      });

      const formatMoney = (cents) => {
        if (typeof cents !== "number") {
          return "";
        }
        const amount = cents / 100;
        return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
          style: "currency",
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD",
        }).format(amount);
      };

      const visibleGalleryItems = () => (window.innerWidth <= 980 ? 1 : 2);

      const buildOfficialGalleryMarkup = (images) => {
        return images
          .map((image, index) => {
            const src = image[0];
            const alt = image[1] || productHandle || "Bombas product";
            const type = image[2] || "IMAGE";
            const fit = bombasGalleryFit(type, alt);
            return (
              '<div class="bombas-pdp-o__media-item bombas-pdp-o__media-item--external" ' +
              'data-gallery-item ' +
              'data-media-id="external-' + (index + 1) + '" ' +
              'data-media-index="' + index + '" ' +
              'data-external-gallery ' +
              'data-gallery-fit="' + fit + '">' +
              '<img src="' + escapeBombasHtml(src) + '" alt="' + escapeBombasHtml(alt) + '" loading="' + (index < 2 ? "eager" : "lazy") + '">' +
              "</div>"
            );
          })
          .join("");
      };

      const renderOfficialGallery = (images) => {
        if (!galleryTrack || !Array.isArray(images) || !images.length) {
          return false;
        }

        galleryTrack.innerHTML = buildOfficialGalleryMarkup(images);
        galleryTrack.classList.toggle("is-single", images.length === 1);
        galleryTrack.setAttribute("data-gallery-mode", "official");
        galleryItems = Array.from(galleryTrack.querySelectorAll("[data-gallery-item]"));
        galleryIndex = 0;
        syncGallery(0);
        return true;
      };

      const syncOfficialGallery = () => {
        if (!officialMediaEntry || !galleryTrack) {
          return false;
        }

        const colorValue = colorOptionIndex > -1 ? normalizeBombasKey(selected[colorOptionIndex]) : "";
        const colorGallery =
          colorValue && officialMediaEntry.c ? officialMediaEntry.c[colorValue] : null;
        const nextKey = colorGallery ? "color:" + colorValue : "default";
        const nextImages =
          (Array.isArray(colorGallery) && colorGallery.length ? colorGallery : officialMediaEntry.d) || [];

        if (!nextImages.length) {
          return false;
        }

        if (officialGalleryKey !== nextKey || galleryTrack.getAttribute("data-gallery-mode") !== "official") {
          officialGalleryKey = nextKey;
          return renderOfficialGallery(nextImages);
        }

        syncGallery(0);
        return true;
      };

      const clampGalleryIndex = (nextIndex) => {
        const maxIndex = Math.max(0, galleryItems.length - visibleGalleryItems());
        return Math.max(0, Math.min(nextIndex, maxIndex));
      };

      const syncGallery = (nextIndex) => {
        if (!galleryTrack || !galleryItems.length) {
          return;
        }

        galleryIndex = clampGalleryIndex(nextIndex);
        galleryTrack.style.setProperty("--bombas-pdp-gallery-index", String(galleryIndex));

        galleryItems.forEach((item, index) => {
          const isVisible = index >= galleryIndex && index < galleryIndex + visibleGalleryItems();
          item.classList.toggle("is-active", isVisible);
        });

        if (galleryCurrentNode) {
          galleryCurrentNode.textContent = String(galleryIndex + 1);
        }

        if (galleryTotalNode) {
          galleryTotalNode.textContent = String(galleryItems.length);
        }
      };

      const findExactVariant = () => {
        return variantPool.find((variant) => {
          return variant.options.every((value, index) => selected[index] === value);
        });
      };

      const findClosestVariant = (changedIndex) => {
        let bestVariant = null;
        let bestScore = -1;

        variantPool.forEach((variant) => {
          if (typeof changedIndex === "number" && variant.options[changedIndex] !== selected[changedIndex]) {
            return;
          }

          let score = 0;
          variant.options.forEach((value, index) => {
            if (selected[index] === value) {
              score += index === changedIndex ? 3 : 1;
            }
          });

          if (variant.available) {
            score += 0.25;
          }

          if (!bestVariant || score > bestScore) {
            bestVariant = variant;
            bestScore = score;
          }
        });

        return bestVariant;
      };

      const findVariant = (changedIndex) => {
        const exactVariant = findExactVariant();
        if (exactVariant) {
          return exactVariant;
        }

        const fallbackVariant = findClosestVariant(changedIndex);
        if (fallbackVariant) {
          fallbackVariant.options.forEach((value, index) => {
            selected[index] = value;
          });
        }

        return fallbackVariant;
      };

      const syncThumbs = (mediaId) => {
        thumbButtons.forEach((button) => {
          button.classList.toggle("is-active", button.getAttribute("data-media-id") === String(mediaId));
        });
      };

      const syncCurrentValues = () => {
        optionValueNodes.forEach((node) => {
          const index = Number(node.getAttribute("data-option-current-value"));
          if (!Number.isNaN(index) && typeof selected[index] === "string") {
            node.textContent = selected[index];
          }
        });
      };

      const setMainImage = (src, alt, mediaId) => {
        if (galleryTrack && galleryItems.length) {
          let mediaIndex = -1;

          if (mediaId) {
            mediaIndex = galleryItems.findIndex((item) => item.getAttribute("data-media-id") === String(mediaId));
          }

          if (mediaIndex < 0 && src && Array.isArray(product.media)) {
            mediaIndex = product.media.findIndex((item) => item.src === src);
          }

          if (mediaIndex > -1) {
            syncGallery(mediaIndex);
            return true;
          }
        }

        if (!mainImage || !src) {
          return false;
        }

        if (mainImage.getAttribute("src") !== src) {
          mainImage.src = src;
          mainImage.srcset = "";
        }

        if (alt) {
          mainImage.alt = alt;
        }

        if (mediaId) {
          syncThumbs(mediaId);
        }

        return true;
      };

      const syncVariantMedia = (variant) => {
        if (!variant) {
          return;
        }

        if (syncOfficialGallery()) {
          return;
        }

        if (variant.featured_media) {
          if (setMainImage(
            variant.featured_media.preview_image ? variant.featured_media.preview_image.src : null,
            variant.featured_media.preview_image ? variant.featured_media.preview_image.alt : null,
            variant.featured_media.id
          )) {
            return;
          }
        }

        if (colorOptionIndex > -1) {
          const activeColorButton = optionButtons.find((button) => {
            return (
              Number(button.getAttribute("data-option-index")) === colorOptionIndex &&
              button.getAttribute("data-option-value") === selected[colorOptionIndex]
            );
          });

          if (activeColorButton) {
            const imageSrc = activeColorButton.getAttribute("data-option-image-src");
            const imageAlt = activeColorButton.getAttribute("data-option-image-alt");
            const mediaId = activeColorButton.getAttribute("data-option-media-id");

            if (imageSrc) {
              setMainImage(imageSrc, imageAlt, mediaId);
            }
          }
        }
      };

      const syncOptions = (variant) => {
        const hasTwoPrimaryOptions = colorOptionIndex > -1 && sizeOptionIndex > -1;
        optionButtons.forEach((button) => {
          const index = Number(button.getAttribute("data-option-index"));
          const value = button.getAttribute("data-option-value");
          const isActive = selected[index] === value;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
          if (variant) {
            const matching = variantPool.some((item) => {
              if (item.options[index] !== value) {
                return false;
              }
              return item.options.every((option, optionIndex) => {
                if (optionIndex === index) {
                  return true;
                }
                if (hasTwoPrimaryOptions && index === colorOptionIndex && optionIndex === sizeOptionIndex) {
                  return true;
                }
                return selected[optionIndex] === option;
              });
            });
            button.disabled = !matching;
            button.hidden = !matching;
          }
        });
      };

      const syncVariant = (variant) => {
        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = "Unavailable";
          }
          syncCurrentValues();
          syncOptions(null);
          return;
        }

        if (variantInput) {
          variantInput.value = variant.id;
        }

        priceNodes.forEach((node) => {
          node.textContent = formatMoney(variant.price);
        });

        compareNodes.forEach((node) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            node.textContent = formatMoney(variant.compare_at_price);
            node.hidden = false;
          } else {
            node.hidden = true;
          }
        });

        savingsNodes.forEach((node) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            node.textContent = `${percent}% Pack Savings`;
            node.hidden = percent <= 0;
          } else {
            node.hidden = true;
          }
        });

        if (addButton) {
          const canAdd = variant.available && Number(variant.price) > 0;
          addButton.disabled = !canAdd;
          addButton.textContent = canAdd ? "Add to Bag" : "Unavailable";
        }

        syncVariantMedia(variant);

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.delete("variant");
        window.history.replaceState({}, "", nextUrl.toString());
        syncCurrentValues();
        syncOptions(variant);
      };

      optionButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          const index = Number(button.getAttribute("data-option-index"));
          const value = button.getAttribute("data-option-value");
          selected[index] = value;
          syncVariant(findVariant(index));
        });
      });

      thumbButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          const image = button.getAttribute("data-image-src");
          const mediaId = button.getAttribute("data-media-id");
          if (mainImage && image) {
            mainImage.src = image;
            mainImage.srcset = "";
          }
          syncThumbs(mediaId);
        });
      });

      if (galleryPrev) {
        galleryPrev.addEventListener("click", function (event) {
          event.preventDefault();
          syncGallery(galleryIndex - 1);
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener("click", function (event) {
          event.preventDefault();
          syncGallery(galleryIndex + 1);
        });
      }

      if (isOfficialPdp && galleryTrack && galleryItems.length) {
        const initialMediaId = selectedVariant.featured_media ? selectedVariant.featured_media.id : galleryItems[0].getAttribute("data-media-id");
        const initialIndex = galleryItems.findIndex((item) => item.getAttribute("data-media-id") === String(initialMediaId));
        syncGallery(initialIndex > -1 ? initialIndex : 0);

        window.addEventListener("resize", function () {
          syncGallery(galleryIndex);
        });
      }

      syncVariant(selectedVariant);

      if (isOfficialPdp && productHandle && mediaManifestUrl) {
        loadBombasMediaManifest(mediaManifestUrl).then((manifest) => {
          if (!manifest || !manifest[productHandle]) {
            return;
          }
          officialMediaEntry = manifest[productHandle];
          syncVariant(findVariant());
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCardSwatches(document);
    initHeaderMega(document);
    initHeaderDrawer(document);
    initSizeGuideModal(document);
    initProductDetailsModal(document);
    initProductForms(document);
  });
})();
